import { useMigratedReport } from './useMigrateReport';
import { buildSucceededAsyncData, isFailed, isLoading } from 'reporting-data/asyncData/AsyncData';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
// @ts-expect-error Untyped dependency
import ReportErrored from '../../reports/inferLogic/components/states/ReportErrored';
import { jsx as _jsx } from "react/jsx-runtime";
export const MigratedReportLoadWrapper = function MigratedReportLoadWrapper(migratedReportLoadWrapperProps) {
  const {
    report,
    props,
    ChildComponent,
    onlyRunReversibleMigrations
  } = migratedReportLoadWrapperProps;
  const asyncReport = useMigratedReport({
    asyncReport: buildSucceededAsyncData(report),
    onlyRunReversibleMigrations
  });
  if (isLoading(asyncReport)) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {
      grow: true
    });
  }
  if (isFailed(asyncReport)) {
    return /*#__PURE__*/_jsx(ReportErrored, {
      error: asyncReport.error
    });
  }
  const {
    data: migratedReport
  } = asyncReport;
  return /*#__PURE__*/_jsx(ChildComponent, Object.assign({}, props, {
    report: migratedReport
  }));
};